module.exports = __webpack_public_path__ + "img/小区概况.2365d13c.png";